module.exports = __webpack_public_path__ + "static/img/img.ba30d82c.png";